module.exports = "/packs/she-e9ab1b01243f713d6785bc59f658e2ae.png";